/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

class WrapperCampaign {

  static create(SuiteAPI) {
    return SuiteAPI.campaign || {
      id: null,
      persPrefix: '$',
      persSuffix: '$'
    };
  }

}

module.exports = WrapperCampaign;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./connect/wrapper/campaign.js
 **/